<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月22日 11:02:57 +0800
 * @最后修改时间: 2022-07-26 17:09:44
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterRecord\components\DaySelect.vue
 -->
<template>
  <v-container
    class="max-width pa-0 align-items-end align-end text-center pb-2"
    :class="isBetween ? 'primary lighten-4' : 'white'"
  >
    <!-- <div class="curcircle" v-if="isNow"></div> -->
    <div class="d-flex justify-end flex-column">
      <div
        class="text-h4 font-weight-medium"
        :class="
          isLiu
            ? 'red--text'
            : isBetween
            ? 'text--primary'
            : isNow
            ? ''
            : 'text--secondary'
        "
      >
        {{ day }}
      </div>
      <div
        class="text-caption-xs"
        :class="
          isLiu
            ? 'red--text'
            : isBetween
            ? 'text--primary'
            : isNow
            ? ''
            : 'text--secondary'
        "
      >
        {{ $t(week) }}
      </div>
    </div>
  </v-container>
</template>
<script>
import dayjs from "dayjs";
var isBetween = require("dayjs/plugin/isBetween");
dayjs.extend(isBetween);
export default {
  name: "DaySelect",
  props: {
    time: { default: "", type: String },
    selectStartDate: { default: "", type: String },
    selectEndDate: { default: "", type: String },
  },
  computed: {
    isBetween() {
      if (!this.selectStartDate || !this.selectEndDate) return false;
      return dayjs(this.time).isBetween(
        this.selectStartDate,
        this.selectEndDate,
        null,
        "[]"
      );
    },
    isNow() {
      if (this.time) {
        if (
          dayjs(this.time).format("YYYY-MM-DD") ===
          dayjs(new Date()).format("YYYY-MM-DD")
        ) {
          return true;
        }
      } else {
        return false;
      }
    },
    day() {
      if (this.time) {
        return dayjs(this.time).get("date");
      } else {
        return "";
      }
    },
    week() {
      const that = this;
      if (this.time) {
        switch (dayjs(this.time).get("day")) {
          case 0:
            // that.isLiu = true;//2021-10-22 julia 取消标红星期天
            that.isLiu = false;
            return "label_essweb_system_sundayLabel"; //Sun
            break;
          case 1:
            that.isLiu = false;
            return "label_essweb_system_mondayLabel"; //Mon
            break;
          case 2:
            that.isLiu = false;

            return "label_essweb_system_tuesdayLabel"; //Tues
            break;
          case 3:
            that.isLiu = false;

            return "label_essweb_system_wednesdayLabel"; //Wed
            break;
          case 4:
            that.isLiu = false;
            return "label_essweb_system_thursdayLabel"; //Thur
            break;
          case 5:
            that.isLiu = false;

            return "label_essweb_system_fridayLabel"; //Fri
            break;
          case 6:
            that.isLiu = false;

            return "label_essweb_system_saturdayLabel"; //Sat
            break;
          default:
            break;
        }
      } else {
        return "";
      }
    },
  },
  data() {
    return { isLiu: false };
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.curcircle {
  width: 50px;
  height: 50px;
  border: 2px solid var(--main-color);
  border-radius: 50px;
  position: absolute;
  margin-left: calc(50% - 25px);
  margin-top: 1px;
}
</style>
